<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title>
          CANCELAMENTO DE FATURA DE ROYALTIES INDIVIDUAL
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <alert
        :type="typeAlert"
        :visible="showAlert"
        :message="messageAlert"
        :clickClose="() => (showAlert = false)"
      ></alert>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="12" md="6" lg="6" class="py-1">
              <v-select
                :items="companies"
                :item-text="(item) => `${item.code} - ${item.name}`"
                item-value="id"
                v-model="company"
                label="Franqueado"
                hide-details
                clearable
                dense
                outlined
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" md="3" class="">
              <v-text-field
                label="Número do Faturamento"
                v-model="code"
                @blur="handleBlurCode()"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" md="3" class="">
              <v-select
                :items="reasons"
                item-text="description"
                item-value="id"
                v-model="reason"
                label="Motivo de Cancelamento"
                hide-details
                clearable
                dense
                outlined
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" md="6" class="py-1">
              <v-textarea
                label="Observação"
                v-model="observation"
                class="text-field-uppercase"
                rows="3"
                no-resize
                outlined
                dense
                hide-details
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" md="12" class="py-1">
              <v-btn color="" small class="mt-1 float-right" @click="clear()"
                >Cancelar</v-btn
              >
              <v-btn
                color="blue darken-3"
                small
                class="mt-1 mr-3 float-right white--text"
                @click="handleCancellation()"
              >
                Confirmar
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" md="12" class="py-1">
              <v-divider></v-divider>
              <v-row style="margin-right: 0px">
                <v-col cols="3"></v-col>
                <v-col cols="5">
                  <v-card outlined class="mt-3 align-center" width="450px">
                    <v-card-text>
                      <v-row>
                        <v-col
                          cols="8"
                          class="
                            py-0
                            caption
                            text-right
                            font-weight-black
                            black--text
                          "
                          >TOTAL DE DOCUMENTOS:</v-col
                        >
                        <v-col
                          cols="4"
                          class="
                            py-0
                            caption
                            text-right
                            font-weight-black
                            black--text
                          "
                          >{{ getTotalInvoices() | currencyEuaToBr }}</v-col
                        >
                        <v-col
                          cols="8"
                          class="
                            py-0
                            caption
                            text-right
                            font-weight-black
                            black--text
                          "
                          >QUANTIDADE TOTAL:</v-col
                        >
                        <v-col
                          cols="4"
                          class="
                            py-0
                            caption
                            text-right
                            font-weight-black
                            black--text
                          "
                          >{{ getTotalItemsInvoices() }}</v-col
                        >
                        <v-col
                          cols="8"
                          class="
                            py-0
                            caption
                            text-right
                            font-weight-black
                            black--text
                          "
                          >VALOR TOTAL DOS PRODUTOS:</v-col
                        >
                        <v-col
                          cols="4"
                          class="
                            py-0
                            caption
                            text-right
                            font-weight-black
                            black--text
                          "
                          >{{ getTotalInvoices() | currencyEuaToBr }}</v-col
                        >
                        <v-col
                          cols="8"
                          class="
                            py-0
                            caption
                            text-right
                            font-weight-black
                            red--text
                          "
                          >(-) TOTAL DOS ABATIMENTOS:</v-col
                        >
                        <v-col
                          cols="4"
                          class="
                            py-0
                            caption
                            text-right
                            font-weight-black
                            red--text
                          "
                          >{{
                            getTotalReleases("desconto") | currencyEuaToBr
                          }}</v-col
                        >
                        <v-col
                          cols="8"
                          class="
                            py-0
                            caption
                            text-right
                            font-weight-black
                            green--text
                          "
                          >(+) TOTAL DOS ACRÉSCIMOS:</v-col
                        >
                        <v-col
                          cols="4"
                          class="
                            py-0
                            caption
                            text-right
                            font-weight-black
                            green--text
                          "
                          >{{
                            getTotalReleases("acrescimo") | currencyEuaToBr
                          }}</v-col
                        >
                        <v-col cols="12" class="py-1">
                          <v-divider></v-divider>
                        </v-col>
                        <v-col
                          cols="8"
                          class="
                            py-0
                            caption
                            text-right
                            font-weight-black
                            black--text
                          "
                          >BASE DE CALCULO DOS ROYALTIES:</v-col
                        >
                        <v-col
                          cols="4"
                          class="
                            py-0
                            caption
                            text-right
                            font-weight-black
                            black--text
                          "
                          >{{ getTotalInvoices() | currencyEuaToBr }}</v-col
                        >
                        <v-col cols="12" class="py-1">
                          <v-divider></v-divider>
                        </v-col>
                        <v-col
                          cols="8"
                          class="
                            py-0
                            caption
                            text-right
                            font-weight-black
                            blue--text
                          "
                          >TOTAL DOS ROYALTIES A PAGAR:</v-col
                        >
                        <v-col
                          cols="4"
                          class="
                            py-0
                            caption
                            text-right
                            font-weight-black
                            blue--text
                          "
                          >{{
                            getTotalRoyaltiesBeforeReleases() | currencyEuaToBr
                          }}</v-col
                        >
                        <v-col
                          cols="8"
                          class="
                            py-0
                            caption
                            text-right
                            font-weight-black
                            black--text
                          "
                          >TOTAL DOS LANÇAMENTOS:</v-col
                        >
                        <v-col
                          cols="4"
                          class="
                            py-0
                            caption
                            text-right
                            font-weight-black
                            black--text
                          "
                          >{{ getTotalReleases() | currencyEuaToBr }}</v-col
                        >
                        <v-col cols="12" class="py-1">
                          <v-divider></v-divider>
                        </v-col>
                        <v-col
                          cols="8"
                          class="
                            py-0
                            caption
                            text-right
                            font-weight-black
                            black--text
                          "
                          >TOTAL DO FATURAMENTO:</v-col
                        >
                        <v-col
                          cols="4"
                          class="
                            py-0
                            caption
                            text-right
                            font-weight-black
                            black--text
                          "
                          >{{ royalties.value | currencyEuaToBr }}</v-col
                        >
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
  </div>
</template>
<script>
import { URL } from "@/api/config";

import * as CompanyAPI from "@/api/requests/CompanyRequest";

import Alert from "@/components/Alert";
export default {
  components: { Alert },
  data: () => ({
    companies: [],
    company: "",
    code: "",
    observation: "",
    royalties: {},
    loading: false,
    showAlert: false,
    messageAlert: false,
    typeAlert: "error",
    lazy: false,
    valid: true,
    reasons: [],
    reason: "",
  }),
  computed: {},
  filters: {
    currencyEuaToBr: function (value) {
      if (!value) return "0,00";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      this.getCompanies();
      this.getReasons();
    },
    async getCompanies() {
      this.loading = true;
      try {
        let data = await CompanyAPI.getAll("?type=fra,mul");
        this.companies = data.sort((a, b) => (a.code > b.code ? 1 : -1));
      } catch (error) {
        this.companies = [];
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async getReasons() {
      this.loading = true;
      try {
        let response = await fetch(`${URL}reason-cancellation-royalties`);
        let data = await response.json();
        this.reasons = data.sort((a, b) =>
          a.description > b.description ? 1 : -1
        );
      } catch (error) {
        this.reasons = [];
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    validate() {},
    clear() {
      this.loading = false;
      // this.showAlert = false;
      this.company = "";
      this.code = "";
      this.observation = "";
      this.royalties = {};
      this.reason = "";
    },
    async handleBlurCode() {
      if (this.company === "") {
        return false;
      }
      if (this.code == "") {
        return false;
      }
      let data = { company_id: this.company, code: this.code };
      this.royalties = {};
      this.showAlert = false;
      try {
        this.loading = true;
        let myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let res = await fetch(`${URL}royalty/search_cancel`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        if (!res.ok) {
          throw new Error(res.message);
        }
        let response = await res.json();

        if (Object.keys(response.royalties).length === 0) {
          this.typeAlert = "warning";
          this.messageAlert = "Fatura não encontrada";
          this.showAlert = true;
        } else {
          console.group("FATURA");
          console.log(response);
          console.groupEnd();
          this.royalties = response.royalties;
        }
      } catch (error) {
        console.log(error.message);
        this.typeAlert = "error";
        this.messageAlert =
          "Houve um problema ao buscar essa fatura, tente novamente mais tarde";
        this.showAlert = true;
      } finally {
        this.loading = false;
      }
    },
    getTotalInvoices() {
      if (Object.keys(this.royalties).length === 0) {
        return 0;
      }
      return this.royalties.invoices
        .map((item) => parseFloat(item.invoice.value))
        .reduce((prev, curr) => prev + curr, 0);
    },
    getTotalItemsInvoices() {
      if (Object.keys(this.royalties).length === 0) {
        return 0;
      }
      return this.royalties.invoices
        .map((item) => parseInt(item.invoice.quantity))
        .reduce((prev, curr) => prev + curr, 0);
    },
    async handleCancellation() {
      if (this.company === "") {
        this.typeAlert = "error";
        this.messageAlert = "Selecione o Franqueado para poder continuar";
        this.showAlert = true;
        return false;
      }
      if (this.code == "") {
        this.typeAlert = "error";
        this.messageAlert =
          "Preencha o número do Faturamento para poder continuar";
        this.showAlert = true;
        return false;
      }
      if (this.reason == "") {
        this.typeAlert = "error";
        this.messageAlert =
          "Selecione um Motivo de Cancelamento para poder continuar";
        this.showAlert = true;
        return false;
      }
      if (this.observation == "") {
        this.typeAlert = "error";
        this.messageAlert = "Preencha uma observação para poder continuar";
        this.showAlert = true;
        return false;
      }
      if (this.royalties == {}) {
        this.typeAlert = "error";
        this.messageAlert =
          "É necessário preencher um número de faturamento válido";
        this.showAlert = true;
        return false;
      }
      let data = {
        company_id: this.company,
        code: this.code,
        reason_cancellation_royalty_id: this.reason,
        observation: this.observation.toUpperCase(),
        value: this.getTotalInvoices(),
        royalties: this.royalties.value,
        date_billing: `${this.royalties.year_billing}-${this.royalties.month_billing}-01`,
        data_royalties: this.royalties,
      };
      console.log(data);
      try {
        this.loading = true;
        let myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let res = await fetch(`${URL}royalty/cancellation`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        if (!res.ok) {
          throw new Error(res.message);
        }
        let response = await res.json();
        this.typeAlert = "success";
        this.messageAlert = "Fatura Cancelada com sucesso";
        this.showAlert = true;
        this.clear();
        console.log(response);
      } catch (error) {
        console.log(error.message);
        this.typeAlert = "error";
        this.messageAlert =
          "Houve um problema ao cancelar essa fatura, tente novamente mais tarde";
        this.showAlert = true;
      } finally {
        this.loading = false;
        this.$vuetify.goTo(0, {
          duration: 300,
          offset: 0,
          easing: "easeInOutCubic",
        });
      }
      // royalty/cancellation
    },
    getTotalReleases(operation = null) {
      if (typeof this.royalties.releases === "undefined") return 0;
      if (operation !== null) {
        return this.royalties.releases
          .filter((item) => item.release.operation === operation)
          .map((item) => parseFloat(item.value))
          .reduce((prev, curr) => prev + curr, 0)
          .toFixed(2);
      } else {
        return this.royalties.releases
          .map((item) =>
            item.release.operation === "desconto"
              ? parseFloat(item.value) * -1
              : parseFloat(item.value)
          )
          .reduce((prev, curr) => prev + curr, 0)
          .toFixed(2);
      }
    },
    getTotalRoyaltiesBeforeReleases() {
      return this.royalties.value - parseFloat(this.getTotalReleases());
    },
  },
};
</script>
<style>
.text-field-uppercase input,
.text-field-uppercase textarea {
  text-transform: uppercase;
}
</style>
